import produce from "immer";
import {
  GET_TERM_CUSTOMIZATION_REQUEST,
  GET_TERM_CUSTOMIZATION_SUCCESS,
  GET_TERM_CUSTOMIZATION_ERROR,
  SET_TERM_CUSTOMIZATION_ENABLED_REQUEST,
  SET_TERM_CUSTOMIZATION_ENABLED_SUCCESS,
  SET_TERM_CUSTOMIZATION_ENABLED_ERROR,
  UPSERT_TERM_CUSTOMIZATION_REQUEST,
  UPSERT_TERM_CUSTOMIZATION_SUCCESS,
  UPSERT_TERM_CUSTOMIZATION_ERROR,
  DELETE_TERM_CUSTOMIZATION_REQUEST,
  DELETE_TERM_CUSTOMIZATION_SUCCESS,
  DELETE_TERM_CUSTOMIZATION_ERROR,
} from "../types";

const initialState = {
  enabled: false,
  terms: [],
  isFetching: false,
  isUpdating: false,
  error: null,
};

const upsertTermInList = (terms, dto) => {
  const normalizedDto = {
    ...dto,
    term_key: dto?.term_key ?? dto?.termKey,
    custom_value: dto?.custom_value ?? dto?.customValue,
  };
  const next = terms.slice();
  const idx = next.findIndex(
    (tt) =>
      String(tt?.term_key ?? tt?.termKey ?? "").trim().toUpperCase() ===
      String(normalizedDto.term_key ?? "").trim().toUpperCase()
  );
  if (idx >= 0) next[idx] = normalizedDto;
  else next.push(normalizedDto);
  return next;
};

export default function termCustomizationReducer(state = initialState, action) {
  switch (action.type) {
    case GET_TERM_CUSTOMIZATION_REQUEST:
      return produce(state, (d) => {
        d.isFetching = true;
        d.error = null;
      });
    case GET_TERM_CUSTOMIZATION_SUCCESS:
      return produce(state, (d) => {
        d.isFetching = false;
        d.enabled = !!action.payload.enabled;
        d.terms = Array.isArray(action.payload.terms) ? action.payload.terms : [];
      });
    case GET_TERM_CUSTOMIZATION_ERROR:
      return produce(state, (d) => {
        d.isFetching = false;
        d.error = action.payload;
      });
    case SET_TERM_CUSTOMIZATION_ENABLED_REQUEST:
    case UPSERT_TERM_CUSTOMIZATION_REQUEST:
    case DELETE_TERM_CUSTOMIZATION_REQUEST:
      return produce(state, (d) => {
        d.isUpdating = true;
        d.error = null;
      });
    case SET_TERM_CUSTOMIZATION_ENABLED_SUCCESS:
      return produce(state, (d) => {
        d.isUpdating = false;
        d.enabled = !!action.payload.enabled;
        d.terms = Array.isArray(action.payload.terms) ? action.payload.terms : [];
      });
    case UPSERT_TERM_CUSTOMIZATION_SUCCESS:
      return produce(state, (d) => {
        d.isUpdating = false;
        d.terms = upsertTermInList(d.terms, action.payload);
      });
    case DELETE_TERM_CUSTOMIZATION_SUCCESS:
      return produce(state, (d) => {
        d.isUpdating = false;
        d.terms = d.terms.filter((tt) => tt.term_key !== action.payload);
      });
    case SET_TERM_CUSTOMIZATION_ENABLED_ERROR:
    case UPSERT_TERM_CUSTOMIZATION_ERROR:
    case DELETE_TERM_CUSTOMIZATION_ERROR:
      return produce(state, (d) => {
        d.isUpdating = false;
        d.error = action.payload;
      });
    default:
      return state;
  }
}
